import React, { Component } from 'react';
import { View, TouchableOpacity, UIManager, LayoutAnimation } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { isNil as _isNil } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, IconTypesValues } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { colorPropType } from '@vfgroup-oneplatform/foundation/Utils/PropTypesValidators';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import ListItem from '../ListItem/ListItem';

import styles from './List.styles';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: _isNil(this.props.moreText),
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showMore !== prevState.showMore) {
      UIManager.setLayoutAnimationEnabledExperimental &&
        UIManager.setLayoutAnimationEnabledExperimental(true);
      LayoutAnimation.create(500, 'spring', 'opacity');
    }
  }
  onShowMorePress = () => {
    this.setState({
      showMore: !this.state.showMore,
    });
  };

  renderShowMoreButton = () => {
    const { items, moreText, lessText, theme } = this.props;
    const itemsLength = items ? items.length : 0;
    if (_isNil(moreText) || itemsLength <= 3) {
      return null;
    }
    return (
      <TouchableOpacity
        style={styles.showMoreButtonStyle}
        onPress={this.onShowMorePress}
        testID={FrameworkTestKeys.DBbasicsShowMore}
      >
        <VFText
          style={styles.showMoreTextStyle(theme)}
          i18nKey={this.state.showMore ? lessText : moreText}
          testKey={FrameworkTestKeys.DBbasicsShowMoreText}
        />
      </TouchableOpacity>
    );
  };

  render() {
    const {
      title,
      items,
      style,
      headerContainerStyle,
      headerStyle,
      itemsContainerStyle,
      images,
      viewAccessibilityLabel,
      listTitleAccessibilityLabel,
      itemsAccessibilityLabel,
      theme,
    } = this.props;

    const renderedItems = this.state.showMore ? items : items.slice(0, 3);

    return (
      <View
        style={[styles.containerStyle, style, { backgroundColor: theme.colors.backgroundColor }]}
        testID={viewAccessibilityLabel}>
        <View
          style={[styles.headerContainerStyle, headerContainerStyle, { backgroundColor: theme.colors.backgroundColor }]}
          testID={FrameworkTestKeys.dashboardListView}
        >
          <VFText
            style={[styles.headerStyle(theme), headerStyle]}
            i18nKey={title}
            testKey={listTitleAccessibilityLabel}
          />
        </View>
        <View
          style={[styles.itemsContainerStyle, itemsContainerStyle]}
          testID={itemsAccessibilityLabel}
        >
          {renderedItems &&
            renderedItems.map((item, index) => {
              const {
                extraInfo,
                leftIconType,
                leftIconSize,
                leftIconColor,
                leftIconStyle,
                buttonDisabled,
                buttonText,
                buttonStyle,
                buttonDisabledStyle,
                buttonTextStyle,
                buttonDisabledTextStyle,
                onPress,
                textStyle,
                isClickable,
                containerStyle,
                showRightIcon,
                rightIconType,
                rightIconName,
                rightIconSize,
                rightIconColor,
                rightIconStyle,
                itemAccessibilityLabel,
                itemButtonAccessibilityLabel,
                itemRightIconAccessibilityLabel,
                itemTitleAccessibilityLabel,
                itemIconAccessibilityLabel,
                blackTint
              } = item;
              return (
                <ListItem
                  index={index}
                  key={index}
                  title={extraInfo.title}
                  leftIconType={leftIconType}
                  leftIconName={extraInfo.icon}
                  leftIconSize={leftIconSize}
                  leftIconColor={leftIconColor}
                  leftIconStyle={leftIconStyle}
                  buttonDisabled={buttonDisabled}
                  buttonText={buttonText}
                  buttonStyle={buttonStyle}
                  buttonDisabledStyle={buttonDisabledStyle}
                  buttonTextStyle={buttonTextStyle}
                  buttonDisabledTextStyle={buttonDisabledTextStyle}
                  onPress={onPress}
                  textStyle={textStyle}
                  isClickable={isClickable}
                  containerStyle={containerStyle}
                  showRightIcon={showRightIcon}
                  rightIconType={rightIconType}
                  rightIconName={rightIconName}
                  rightIconSize={rightIconSize}
                  rightIconColor={rightIconColor}
                  rightIconStyle={rightIconStyle}
                  buttonType={item.buttonType}
                  images={images}
                  itemButtonAccessibilityLabel={itemButtonAccessibilityLabel}
                  itemRightIconAccessibilityLabel={itemRightIconAccessibilityLabel}
                  itemTitleAccessibilityLabel={itemTitleAccessibilityLabel}
                  itemIconAccessibilityLabel={itemIconAccessibilityLabel}
                  itemAccessibilityLabel={itemAccessibilityLabel}
                  blackTint={blackTint}
                />
              );
            })}
          {this.renderShowMoreButton()}
        </View>
      </View>
    );
  }
}

List.defaultProps = {
  style: {},
  headerContainerStyle: {},
  headerStyle: {},
  itemsContainerStyle: {},
  theme: LightThemeColors,
};

List.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      extraInfo: PropTypes.shape({
        title: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
      }).isRequired,
      onPress: PropTypes.func.isRequired,
      containerStyle: ViewPropTypes.style,
      textStyle: TextPropTypes.style,
      leftIconType: PropTypes.oneOf(IconTypesValues).isRequired,
      leftIconSize: PropTypes.number,
      leftIconColor: colorPropType,
      leftIconStyle: ViewPropTypes.style,
      showRightIcon: PropTypes.bool,
      rightIconType: PropTypes.oneOf(IconTypesValues),
      rightIconName: PropTypes.string,
      rightIconSize: PropTypes.number,
      rightIconColor: colorPropType,
      rightIconStyle: ViewPropTypes.style,
      isClickable: PropTypes.bool,
      buttonText: PropTypes.string,
      buttonStyle: ViewPropTypes.style,
    }).isRequired,
  ).isRequired,
  moreText: PropTypes.string.isRequired,
  lessText: PropTypes.string.isRequired,
  style: ViewPropTypes.style,
  headerContainerStyle: ViewPropTypes.style,
  headerStyle: TextPropTypes.style,
  itemsContainerStyle: ViewPropTypes.style,
  viewAccessibilityLabel: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  images: PropTypes.object,
  listTitleAccessibilityLabel: PropTypes.string,
  itemsAccessibilityLabel: PropTypes.string,
};

export default withTheme(List);
